
<script setup>

import { useMediaQuery } from '@vueuse/core'

import Button from './button.vue'

defineProps( [ 'eyebrow', 'heading', 'paragraph', 'buttonText', 'buttonLink' ] )

const buttonBreakpoint = useMediaQuery( '(min-width: 640px)' )

</script>

<template>

  <div class="bg-blue-primary px-4 py-8 sm:p-8 flex flex-col justify-center items-center max-w-96">

    <p class="text-green-bitter-lemon text-sm sm:text-base font-bold uppercase mb-4">{{ eyebrow }}</p>

    <h2 class="text-white font-bold text-center text-xl sm:text-2xl mb-3">{{ heading }}</h2>

    <p class="text-white text-center sm:text-lg mb-8">{{ paragraph }}</p>

    <Button :size="buttonBreakpoint ? '' : 'sm'" class="text-blue-primary bg-green-bitter-lemon hover:bg-green-rio whitespace-nowrap capitalize">

      <slot name="button"></slot>

    </Button>

  </div>

</template>
